import { HttpContextToken, HttpRequest } from '@angular/common/http';

const authEndpoint = /api\/v1\/auth/gi;

const authEndpoints = [
  '/api/v1/auth/logout',
  '/api/v1/auth/profile',
  '/api/v1/auth/profile/password/update',
  '/api/v1/auth/profile/password/create',
  '/api/v1/auth/profile/social/google/link',
  '/api/v1/auth/profile/social/facebook/link',
  '/api/v1/auth/profile/social/apple/link',
  '/api/v1/auth/currentuser',
];

/**
 * Marks the customer's own "Log out" (story #11691). `POST /api/v1/auth/logout`
 * revokes the account whose JWT it carries, and admin order capture can hold a
 * backoffice and a customer session in one browser, so this request must carry
 * the customer's JWT. The backoffice's own logout posts to the same URL
 * unmarked and keeps the backoffice JWT.
 */
export const CUSTOMER_LOGOUT = new HttpContextToken<boolean>(() => false);

export function isNonAuthEndpoint(request: HttpRequest<any>) {
  return (
    authEndpoints.includes(request.url) ||
    request.url.search(authEndpoint) === -1
  );
}

export function addToken(request: HttpRequest<any>, token: string) {
  return request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function extractTokenFromUrl(): string | null {
  const url = window.location.href;
  let arr = url.split('?');
  if (arr[1]) {
    const token = arr[1].split('=')[1];
    return token;
  }
  return null;
}
